import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";

import { login } from "../../store/actions";
import { useAuth } from "react-oidc-context";
import { getUser, handleOAuthCallback, sendOAuthRequest } from "../../services/AuthSamlService";
import LoadingPage from "./LoadingPage";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { decodeUserSession, sanitizeErrorForLogging } from "../../utils/utils";
import { getLocale } from "../../utils/locale";
import { UserManager } from "oidc-client";
import { getConfigVariable } from "../../config/config";

const SAMLCallback = (props) => {
    const { login, location, match, user } = props;

    const userInformation = decodeUserSession(user);

    const [loginAttempt, setAttempt] = useState(false);

    const [appTheme] = useState(
        getConfigVariable("REACT_APP_COLBI_THEME")
            ? getConfigVariable("REACT_APP_COLBI_THEME").toLocaleLowerCase()
            : document.localStorage.getItem("theme")
              ? document.localStorage.getItem("theme")
              : "sovos",
    );

    const auth = useAuth();

    const locale = getLocale(auth, match);

    const userManager = useMemo(() => {
        return new UserManager(getConfigVariable("AUTH_CONFIG").saml);
    }, []);

    useEffect(() => {
        window.localStorage.setItem("login-mode", "saml");
    }, []);

    useEffect(() => {
        const root = document.getElementsByTagName("html")[0];
        root.setAttribute("class", appTheme);
    }, [appTheme]);

    useEffect(() => {
        if (!auth?.error && !location?.search.includes("state") && !loginAttempt) {
            window.localStorage.setItem("request-sent", "true");
            sendOAuthRequest(userManager);
        }
    }, [location, auth, loginAttempt, userManager]);

    useMemo(() => {
        if (!auth?.error && !loginAttempt && !auth?.isLoading && auth.isAuthenticated) {
            getUser(userManager).then(({ profile, id_token }) => {
                const { email } = profile;
                login(
                    email.toLowerCase(),
                    id_token,
                    "SAML",
                    {
                        setAttempt: setAttempt,
                    },
                    null,
                    getConfigVariable("AUTH_CONFIG")["saml"].jwks_uri,
                    locale,
                    getConfigVariable("REACT_APP_PROXY_HOST"),
                );
            });
            return;
        }
        if (
            !auth?.error &&
            !auth?.isLoading &&
            !auth?.isAuthenticated &&
            window.localStorage.getItem("request-sent") === "true" &&
            !loginAttempt
        ) {
                handleOAuthCallback(userManager).catch((err) => {
                    console.error(sanitizeErrorForLogging(err)); // eslint-disable-line no-console
                });
        }
    }, [auth, login, loginAttempt, locale, userManager]);

    if (!auth?.isLoading && auth?.error) {
        console.error(sanitizeErrorForLogging(auth.error)); // eslint-disable-line no-console
        return <Redirect to={`/${locale}/unauthorized`} />;
    }

    if (loginAttempt && !auth.isLoading && auth.isAuthenticated && !userInformation) {
        return <Redirect to={`/${locale}/forbidden`} />;
    }

    if (!auth?.isLoading && auth.isAuthenticated && loginAttempt && userInformation) {
        window.localStorage.removeItem("request-sent");
        return <Redirect to={`/${locale}`} />;
    }

    return <LoadingPage />;
};

export default connect(({ user }) => ({ user }), { login })(SAMLCallback);
